import A from '../analytics';
import { updateUserDetails } from '../livechat';
import { detectCookies } from '../utils';

export const UPDATE_USER = 'UPDATE_USER';
export const CLEAR_USER = 'CLEAR_USER';

export const updateUser = (data = {}) => {
  if (data.phone && !data.id) {
    // When Only phone is set ( EnterPhone )
    A.logAction('SET_PHONE', data.phone);
    if (!detectCookies()) {
      A.logNoCookies(data.phone);
    }
  }

  // Send user details to live chat
  const { name = null, phone, email = null } = data;
  if (phone) {
    updateUserDetails({ name, phone, email });
  }

  return {
    type: UPDATE_USER,
    data,
  };
};

export const clearUser = () => ({
  type: CLEAR_USER,
});



// WEBPACK FOOTER //
// ./src/actions/userActions.js